export const addressLabel = 'address';
export const serviceDateLabel = 'service date';
export const clientLabel = 'client';
export const packageOrdered = 'package ordered';
export const optionsPurchasedLabel = 'options';
export const statusLabel = 'status';
export const noClientAlert = 'No client!';
export const copySuccessAlert = 'Copied address to your clipboard!';
export const noAddressError = 'Error no address';
